import { register } from './viewbilityTracker'

export function registerExternalScripts() {
  register('.thinkjamEmbedded')
  register('.riddleEmbedded')
  register('.accountantEmbedded')
  register('.streamableEmbedded')
  register('.spotim-circulation')
  register('.deep-itEmbedded')
  register('.top-posts-side-bar__item')
  register('.fantasy-mount-point')
  register('.famEmbedded')
  register('.accountantEmbedded')
  register('.pluralistEmbedded')
  register('.build_legenedEmbedded')
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/viewability/externalScriptsViewabilityRegistration.js